import { useCallback } from "react"

import { useAuth } from "shared/lib/useAuth"
import { useEvent } from "shared/lib/useEvent"

import { useTeamsQuery } from "entities/teams/graphql/queries.generated"
import { Team } from "entities/teams/types/Team"
import { useTeamActionHandlers } from "features/team-management/model/useTeamActionHandlers"
import { useTeamLink } from "features/team-management/model/useTeamLink"

import { TeamListModel } from "../TeamList"

export function useTeamListModel(): TeamListModel {
  // TODO: teams query return only basic data. Disuss with backend to return more info.
  const { loading: isLoadingTeams, error } = useTeamsQuery()
  const handlers = useTeamActionHandlers()
  const { userInfo } = useAuth()
  const { getHref, navigate } = useTeamLink(null)

  const onTeamSelect = useEvent((team: Team) => {
    navigate({ id: team.id })
  })

  const getTeamHref = useCallback(
    (team: Team) => {
      return getHref(team.id)
    },
    [getHref]
  )

  return {
    teams: [],
    userID: userInfo?.id,

    isLoading: isLoadingTeams || !userInfo,
    handlers,

    hasError: !!error,

    getTeamHref,
    onTeamSelect
  }
}
